import Hero from './components/Hero';
import Navbar from './components/Navbar';
import About from './components/About';
import Features from './components/Features';
import Booking from './components/Booking';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Campaign from './components/Campaign';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Campaign />
      <About />
      <Features />
      <Booking />
      <CTA />
      <Footer />
    </div>
  );
}
